import { ImLinkedin2 } from "react-icons/im";
// ...existing code...
import React from 'react';
import rensImage from '../assets/images/rens-profile.webp';
import lunarLogo from '../assets/logos/lunar.png';
import fitincLogo from '../assets/logos/fitinc.png';
import biosphereLogo from '../assets/logos/biosphere.png';
import { Link } from "react-router-dom";

interface HeaderProps {
    title: string;
}
// fixed top-0 left-0
const Header: React.FC<HeaderProps> = ({ title }) => {
    return (
        <header className='flex items-center justify-between px-6 py-6 lg:px-20 lg:py-6  bg-transparent w-full z-10'>
            <Link to='/about' className='flex items-center space-x-3 md:space-x-6'>
                <img
                    src={rensImage}
                    alt='Profile'
                    className='w-10 h-10 lg:w-16 lg:h-16 rounded-full border border-grey object-cover'
                />
                <span className='text-sm md:text-2xl font-semibold text-white'>{title}</span>
            </Link>
            <div className='flex items-center justify-center gap-4 md:gap-8'>
                <a
                    href='https://www.linkedin.com/in/rensterweijde/'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white hover:text-gray-300 text-md sm:text-2xl'
                >
                    <ImLinkedin2 />
                </a>
                <a
                    href='https://www.biosphere.ai/'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white hover:text-gray-300 text-md sm:text-2xl flex items-center justify-center w-2 h-3 md:w-4 md:h-5'
                >
                    <img className='w-full h-full' src={biosphereLogo} alt='lunar-logo' />
                </a>
                <a
                    href='https://lunar.inc/'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white hover:text-gray-300 text-md sm:text-2xl flex items-center justify-center w-2 h-3 md:w-4 md:h-6'
                >
                    <img className='w-full h-full' src={lunarLogo} alt='lunar-logo' />
                </a>
                <a
                    href='https://www.fit.inc/'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white hover:text-gray-300 text-md sm:text-2xl flex items-center justify-center w-3 h-3 md:w-6 md:h-6'
                >
                    <img className='w-full h-full' src={fitincLogo} alt='fitinc-logo' />
                </a>
            </div>
        </header>
    );
};

export default Header;
